export const iconFontAwesomeMedicalHealthUserDoctor = (
	<i className="fa-solid fa-user-doctor"></i>
);
